// https://www.osano.com/cookieconsent/download/
// https://www.osano.com/cookieconsent/documentation/javascript-api/-1
// https://github.com/osano/cookieconsent

// console.log("Cookies!");


function hideOptinsOptouts(optType) {
    optType.forEach((item) => {
        item.setAttribute('style', 'width:100%;height:0;border:0');
        // console.log(item);
    });
}

function enableCookies() {
    optins.forEach((item) => {
        if (item.dataset.src) {
            item.setAttribute("src", item.dataset.src);
            item.setAttribute("style", item.dataset.style);
        }
        if (item.dataset.href) {
            item.setAttribute("href", item.dataset.href);
        }
        // console.log(item);
    });
    hideOptinsOptouts(optouts);
}

let optins = document.querySelectorAll('[data-cookie="optin"]');
hideOptinsOptouts(optins);
let optouts = document.querySelectorAll('[data-cookie="optout"]');

let layoutParts = [
    '<p class="font-bold text-dark">{{header}}</p>',
    '<p>{{message}}</p>',
    '<div class="flex flex-col gap-3 my-4">',
    '<a class="cc-btn cc-allow px-4 py-3 rounded-md text-white bg-gradient-to-t from-secondary to-secondary/90 hover:to-secondary transition text-center text-sm" href="" tabindex="0" aria-label="allow cookies">{{allow}}</a>',
    '<a class="cc-btn cc-deny px-4 py-3 rounded-md text-white bg-gradient-to-t from-secondary to-secondary/90 hover:to-secondary transition text-center text-sm" href="" tabindex="0" aria-label="deny cookies">{{deny}}</a>',
    '</div>',
    '<p class="space-x-4 mx-auto text-sm"><a href="/impressum.html" tabindex="0" target="_blank" class="text-medium underline">Impressum</a> <a href="/datenschutz.html" tabindex="0" target="_blank" class="text-medium underline">Datenschutz</a></p>',
];

let windowParts = [
    '<div',
    'role="dialog"',
    'aria-live="polite"',
    'aria-label="cookieconsent"',
    'aria-describedby="cookieconsent:desc"',
    'class="cc-window fixed inset-0 isolate z-9999 flex items-center justify-center w-full h-full bg-black/80"',
    'x-cloak>',
    '<div class="flex flex-col w-[max(450px,25vw)] mx-auto p-4 md:p-6 lg:p-8 bg-white text-darker border border-medium shadow-md">',
    '<!--googleoff: all-->',
    '{{children}}',
    '<!--googleon: all-->',
    '</div>',
    '</div>',
];

window.cookieconsent.initialise({
    enabled: true,
    container: document.getElementById('cookieconsent-container'),
    type: 'opt-in',
    window: windowParts.join(" "),
    content: {
        header: 'Datenschutz',
        message: 'Wir verwenden Cookies, um unsere Webinhalte zu optimieren und die Zugriffe zu analysieren. Wenn Sie diese Website weiter nutzen, stimmen Sie zu, dass wir dazu Informationen zu Ihrer Nutzung unserer Website an unsere Partner für Analytics, soziale Medien/Personalisierung und Werbeanzeigen weitergeben.',
        deny: 'Notwendige Cookies erlauben',
        allow: 'Alle Cookies erlauben',
        target: '_top',
        policy: 'Cookies',
        link: 'Impressum',
        href: '/impressum.html',
    },
    elements: {
        header: '{{header}}',
        message: '{{message}}',
        allow: '{{allow}}',
        deny: '{{deny}}',
    },
    layouts: {
        basic: layoutParts.join("")
    },
    layout: 'basic',
    revokeBtn: '<div class="cc-revoke fixed left-0 lg:-left-8 hover:left-0 bottom-4 px-2 py-3 vertical-rl rounded-r-md text-light/80 bg-dark/80 hover:bg-dark hover:cursor-pointer">{{policy}}</div>',

    onInitialise: function (status) {
        console.log("onInitialise / status", status);
        let type = this.options.type;
        let didConsent = this.hasConsented();
        if (type === 'opt-in' && didConsent) {
            enableCookies();
        }
    },
    onStatusChange: function (status, chosenBefore) {
        console.log("onStatusChange / status", status);
        let type = this.options.type;
        let didConsent = this.hasConsented();
        if (type === 'opt-in' && didConsent) {
            enableCookies();
        }
    },
    onPopupOpen: function () {
        console.log("onPopupOpen");
        hideOptinsOptouts(optins);
    },
    onPopupClose: function () {
        console.log("onPopupClose");
    }
});
